import React from 'react';
import Header from './Header';
import Footer from './Footer';

export default function PaymentLayout({ children, title = 'Portal de pagos', subtitle = 'Paga tu cotización de forma rápida y segura' }) {
  return (
    <div className="payment-page">
      <a className="skip-link" href="#payment-content">Saltar al contenido</a>
      <Header />
      <main id="payment-content">
        <section className="payment-hero" aria-labelledby="page-title">
          <div className="payment-hero__content">
            <h1 id="page-title">{title}</h1>
            <p>{subtitle}</p>
          </div>
        </section>
        <div className="payment-content">{children}</div>
      </main>
      <Footer />
    </div>
  );
}